export const contentTableConfig = {
  title: '推广素材列表',
  propList: [
    { prop: 'title', label: '标题', minWidth: '120' },
    { prop: 'url', label: '访问链接', minWidth: '80', slotName: 'url' },
    { prop: 'id', label: '复制链接', minWidth: '80', slotName: 'generate' },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '120',
      sortable: true,
      slotName: 'createdTime'
    },
    {
      prop: 'updatedTime',
      label: '更新时间',
      minWidth: '120',
      sortable: true,
      slotName: 'updatedTime'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
